import { Getter, Setter, createLens } from '@dhmk/zustand-lens';
import { Draft } from 'immer';
import type {
  EdgeId,
  EdgeInstance,
  GraphId,
} from '../../components/graph-editor/types/graph';
import type { GraphsSlice } from '.';

export interface IEdge {
  get: () => EdgeInstance;
  getId: () => EdgeId;
  getFrom: () => EdgeInstance['from'];
  getTo: () => EdgeInstance['to'];
  setFrom: (from: EdgeInstance['from']) => void;
  setTo: (to: EdgeInstance['to']) => void;
  setOrder: (order: number) => void;
}

export const createEdgeAPI = (
  _set: Setter<Draft<GraphsSlice>>,
  _get: Getter<Draft<GraphsSlice>>,
  graphId: GraphId,
  edgeId: EdgeId
): IEdge => {
  const [set, get] = createLens(_set, _get, [
    'graphs',
    graphId,
    'edges',
    edgeId,
  ]) as [Setter<Draft<EdgeInstance>>, Getter<Draft<EdgeInstance>>];

  return {
    get: () => get(),
    getId: () => edgeId,
    getFrom: () => get().from,
    getTo: () => get().to,
    setFrom: (from) => {
      set((s) => {
        s.from = from;
      });
    },
    setTo: (to) => {
      set((s) => {
        s.to = to;
      });
    },
    setOrder: (order) => {
      set((s) => {
        s.order = order;
      });
    },
  };
};
